module.exports = __webpack_public_path__ + "img/avp_bck_alt_phone@2x.c69b613.webp";